import { BaseModel } from "@blue-chip/core";
import Contact from "./Contact";
import Project from "./Project";

export default class ProjectMemberContact extends BaseModel {
  static get belongsTo() {
    return [Contact, Project];
  }
}
